import { ITennisTourRanking } from "@sky-it-livedata/livedata-sports-design-system";
import { loggerFactory } from "@sky-it-livedata-libraries/livedata-commons";
import errors from "../../utils/errors";
import { RankingData } from "./types";

const logger = loggerFactory();

const isValidObject = (obj: RankingData) =>
  Boolean(obj?.data?.getRankingWidget);

export const transformQuery = (obj: RankingData): ITennisTourRanking => {
  if (isValidObject(obj)) {
    try {
      const { rankings } = obj?.data?.getRankingWidget!;

      return {
        ranking: rankings?.map((item) => {
          return {
            position: item?.rank,
            flagUrl: item?.nationality,
            name: item?.playerName,
            score: Number(item?.points),
            trend: Number(item?.trend),
            id: item?.rank?.toString(),
      }}),
      } as ITennisTourRanking;
    } catch (error) {
      logger.error(
        "ERROR 3001: transform() error in Ranking transformer",
        obj
      );
      throw errors.fromCode(3001);
    }
  } else {
    logger.error("ERROR 3000", obj);
    throw errors.fromCode(3000);
  }
};
